module.exports = __webpack_public_path__ + "static/media/icon_logo_collapsed.5ba02afc.svg";